import i18n from 'i18next';
import axios, {AxiosError, AxiosInterceptorManager, AxiosResponse} from 'axios';
import {ProblemDetailsType} from '@common/types';

export const createAxios = () => {
  configureInterceptors(axios.interceptors.response);
};

export const configureInterceptors = (response: AxiosInterceptorManager<AxiosResponse>) => {
  response.use(
    (response) => response,
    (error: AxiosError) => {
      const status = error.response?.status ?? 0;

      if (status < 400) {
        console.error(error);
      }

      if (error.response?.data) {
        return Promise.reject(error.response?.data);
      }

      const message = i18n.t(`errors.${error.code?.toLowerCase()}`);

      return Promise.reject(<ProblemDetailsType>{
        status: status,
        detail: message,
        instance: error.request.responseURL,
        title: message,
        type: error.code,
      });
    });
};

const instance = axios.create();
configureInterceptors(instance.interceptors.response);

export const useAxios = () => instance;